<template>
<div>
  <input 
    type="file" 
    id="file" 
    ref="file" 
    class="image__input" 
    @change="onFileUploads" 
  />
  <label for="file" class="image__preview">
    <span v-if="!preview"><i class="fas fa-upload"></i> загрузить</span>
    <img v-else :src="preview" alt="Изображение">
  </label>
</div>
</template>

<script>
export default {
  data() {
    return {
      preview: null
    }
  },
  computed: {
    file() {
      return this.$refs.file.files[0]
    }
  },
  methods: {
    onFileUploads() {
      let file = this.file     

      let reader = new FileReader();      
      reader.readAsDataURL(file);

      reader.addEventListener('load', () => {
        this.preview = reader.result            
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.image__input {
  display: none;
}
.image__preview {
  width: 80px;
  height: 80px;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;

  & span {
    font-size: 13px;
    color: #999999;
    text-align: center;
  }

  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
